<template>
  <div class="list" name="info">
    <el-col style="margin-top:-18px">
      <el-form :inline="true" class="demo-inline-form" :model="search_qrcode">
        <el-card class="searchCard" shadow="never">
          <el-form-item label="生成时间">
            <el-date-picker
              v-model="comeTime"
              type="daterange"
              align="left"
              @change="dateChange"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              clearable
              :picker-options="pickerOptions">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="码牌号">
            <el-input
              style="width:260px;"
              v-model="search_qrcode.FQrcodeNum"
              auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="类型">
            <el-select
              style="width:150px;"
              v-model="search_qrcode.FType"
              placeholder=""
              clearable>
              <el-option label="全部" value=""></el-option>
              <el-option v-for="qrcodeType in qrcodeTypeList" :key="qrcodeType.code" :label="qrcodeType.name" :value="qrcodeType.code"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="交易状态">
            <el-select
              style="width:150px;"
              v-model="search_qrcode.FState"
              placeholder=""
              clearable>
              <el-option label="全部" value=""></el-option>
              <el-option label="开通" value="1"></el-option>
              <el-option label="关闭" value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="分配状态">
            <el-select
              style="width:150px;"
              v-model="search_qrcode.FDistributeState"
              placeholder=""
              clearable>
              <el-option label="全部" value=""></el-option>
              <el-option label="已分配" value="1"></el-option>
              <el-option label="未分配" value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="批次号">
            <el-input
              style="width:250px;"
              v-model="search_qrcode.FBatchNo"
              auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="所属代理/业务员">
            <el-input
              style="width:150px;"
              v-model="search_qrcode.FAgentId"
              auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item>
            <auth-button
              opt="search"
              :plain="true"
              icon="el-icon-search"
              @click.native="buttomSearch"
              :loading="qrcodeLoading"
              label="查询"></auth-button>
            <auth-button opt="batch_distribute" icon="el-icon-edit" @click.native="handleDistribute(null)" label="分配"></auth-button>
          </el-form-item>
          <!-- <el-form-item>
                    <el-button type="primary" icon="el-icon-setting" @click='handleBinding' >绑定</el-button>
                </el-form-item> -->
          <!-- 统计 -->
          <el-col>
            <el-form :inline="true">
              <el-form-item label="统计" style="5%; font-weight: bold;"></el-form-item>
              <el-form-item label="码牌数量：">{{ totalAmountCount.qrCodeCount }}</el-form-item>
              <el-form-item label="待绑定数量：">{{ totalAmountCount.noBindCount }}</el-form-item>
              <el-form-item label="已绑定数量：">{{ totalAmountCount.bindCount }}</el-form-item>
            </el-form>
          </el-col>
        </el-card>
        <el-card class="tableCard" shadow="never">
          <!-- 列表模块 -->
          <el-table
            stripe
            style="width:100%;"
            align="center"
            v-loading="qrcodeLoading"
            :data="qrcode_list"
            :header-cell-style="{background:'#FAFAFA'}"
            @sort-change="tableSortChange"
          >
            <el-table-column
              prop="fBatchNo"
              label="批次号"
              align="center">
            </el-table-column>
            <el-table-column
              prop="fCreateTime"
              label="生成时间"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="fQrcodeNum"
              label="码牌号"
              align="center">
            </el-table-column>
            <el-table-column
              prop="fQrcodeType"
              label="类型"
              :formatter="formatType"
              align="center">
            </el-table-column>
            <el-table-column
              prop="realState"
              label="交易状态"
              :formatter="formatState"
              align="center">
            </el-table-column>
            <el-table-column
              prop="fDistributeState"
              label="分配状态"
              :formatter="formatDistributeState"
              align="center">
            </el-table-column>
            <el-table-column
              prop="fAgentId"
              label="所属代理/业务员"
              align="center">
            </el-table-column>
            <el-table-column
              label="操作"
              width="300"
              align="left"
              fixed="right"
              :context="_self">
              <template slot-scope="scope">
                <auth-button
                  opt="details"
                  icon="el-icon-search"
                  size="mini"
                  v-if="scope.row.fAgentId !== userId"
                  label="查看"
                  @click.native="handleCheck(scope.$index, scope.row)"></auth-button>
                <auth-button
                  opt="distribute"
                  icon="el-icon-edit"
                  size="mini"
                  v-if="scope.row.fDistributeState !== 1"
                  label="分配"
                  @click.native="handleDistribute(scope.row)"></auth-button>
                <auth-button
                  opt="bind"
                  icon="el-icon-edit"
                  size="mini"
                  v-if="scope.row.fBindState !== 1"
                  label="绑定"
                  @click.native="handleSingleBinding(scope.row,scope.$index,qrcode_list)"></auth-button>
                <auth-button
                  opt="cancel_distribute"
                  icon="el-icon-edit"
                  size="mini"
                  label="取消分配"
                  v-if="scope.row.fDistributeState === 1 && scope.row.fBindType ==1"
                  @click.native="cancelDistribute(scope.row,scope.$index,qrcode_list)"></auth-button>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </el-form>
    </el-col>
    <el-col :span="24" class="btm-action">
      <el-pagination
        v-if="paginations.total>0"
        class="pagination"
        :page-sizes="paginations.pageSizes"
        :page-size="paginations.pageSize"
        :layout="paginations.layout"
        :total="paginations.total"
        :pageNum="paginations.pageNum"
        @current-change="onChangeCurrentPage">
      </el-pagination>
    </el-col>

    <!-- 查看界面 -->
    <el-dialog title="" :visible.sync="dialogVisible" size="small" width="35%">
      <div class="codeImgBox">
        <img src="../../../../static/images/unionCode.png" class="top_img codeImg" id="codeImg1" v-if="checkBasic.show">
        <img src="../../../../static/images/unionCode2.png" class="top_img codeImg" id="codeImg2" v-if="!checkBasic.show">
        <img src="../../../../static/images/unionPayDownload.png" class="top_img codeImgDownload hide" v-if="checkBasic.show">
        <img src="../../../../static/images/unionPayDownload2.png" class="top_img codeImgDownload hide" v-if="!checkBasic.show">
        <div class="qr-code-tip-view">
          <div>商户简称:{{ checkBasic.merchantName || '未设置' }}</div>
        </div>
        <div id="img_box"></div>
        <p id="leposNum">NO:<span>{{ checkBasic.qrcodeNum }}</span></p>
        <div id="ewm_img" class="hide">
          <img class="top_img" src="" id="top_img">
        </div>
        <a id="hello"></a>
        <div class="canvas-container hide" style="width: 375px; height: 585px; position: relative; user-select: none;">
          <canvas id="main" width="750" height="1170" class="hide lower-canvas" style="position: absolute; width: 375px; height: 585px; left: 0px; top: 0px; touch-action: none; user-select: none;"></canvas>
          <canvas class="upper-canvas hide" width="375" height="585" style="position: absolute; width: 375px; height: 585px; left: 0px; top: 0px; touch-action: none; user-select: none;"></canvas>
        </div>
      </div>
      <span slot="footer" class="dialog-footer" style="width:100%">
        <el-button icon="el-icon-save" type="primary" @click="saveQrcode()" :loading="checkBasic.checkLoading">保存二维码</el-button>
        <el-button @click="dialogVisible = false" >关  闭</el-button>
      </span>
    </el-dialog>

    <!-- 分配界面 -->
    <el-dialog title="分配界面" :visible.sync="dialogDistribute" size="mini">
      <el-row >
        <el-form label-width="200px" ref="distributeBasic" :model="distributeBasic" :rules="rule_data">
          <el-form-item label="类型" prop="batchType" v-if="showTypeCheckBox">
            <el-select v-model="distributeBasic.batchType">
              <el-option label="全部" value=""></el-option>
              <el-option v-for="qrcodeType in qrcodeTypeList" :key="qrcodeType.code" :label="qrcodeType.name" :value="qrcodeType.code"></el-option>
              <!--                      <el-option label="乐刷收款二维码" value="1"></el-option>-->
              <!--                      <el-option label="聚合码" value="2"></el-option>-->
              <!--                      <el-option label="码牌音箱" value="3"></el-option>-->
              <!--                      <el-option label="银联二维码" value="4"></el-option>-->
              <!--                      <el-option label="小程序二维码" value="5"></el-option>-->
            </el-select>
          </el-form-item>
          <el-form-item label="起始号码" prop="startQrcodeNum">
            <el-input
              v-model="distributeBasic.startQrcodeNum"
              style="width: 30%"
              :disabled="distributeBasic.distributeCodeDisabled"
              @blur="handleDistributeCodeStartBlur"></el-input>
          </el-form-item>
          <el-form-item label="码牌数量" prop="totalQrcodeCount">
            <el-input
              v-model="distributeBasic.totalQrcodeCount"
              style="width: 30%"
              :disabled="distributeBasic.distributeCodeDisabled"
              @blur="handleDistributeCodeCountBlur"></el-input>
          </el-form-item>
          <el-form-item label="终止号码" prop="endQrcodeNum">
            <el-input
              v-model="distributeBasic.endQrcodeNum"
              style="width: 30%"
              :disabled="distributeBasic.distributeCodeDisabled"
              @blur="handleDistributeCodeEndBlur"></el-input>
          </el-form-item>
          <el-form-item label="所属代理/业务员" prop="distributeAgentId">
            <el-input
              v-model="distributeBasic.distributeAgentId"
              style="width: 30%"></el-input>
          </el-form-item>

        </el-form>
      </el-row>
      <span slot="footer" class="dialog-footer" style="width:100%">
        <el-button icon="el-icon-save" type="primary" @click="submitDistribute('distributeBasic')" :loading="distributeBasic.distributeLoading">分配</el-button>
        <el-button @click="dialogDistribute = false" >取消</el-button>
      </span>
    </el-dialog>

    <!-- 码牌绑定 -->
    <!-- <el-dialog title="码牌绑定" :visible.sync="dialogBinding" size="small">
        <el-row >
            <el-form label-width="100px"
              ref="bindingBasic"
              :model="bindingBasic"
              :rules="rule_data">
               <el-form-item label="绑定人" prop="fNopassReason">
                <el-input v-model="bindingBasic.fNopassReason" style="width: 30%"  prop="fNopassReason" :disabled = 'true'></el-input>
                <label style="margin:0 60px">批次号</label>
                <el-input v-model="bindingBasic.headShopMerchantId"  style="width: 30%" :disabled = 'true'></el-input>
              </el-form-item>
              <el-form-item label="代理商" prop="fUserName">
                <el-input v-model="bindingBasic.headShopMerchantId"  style="width: 30%" :disabled = 'true'></el-input>
              </el-form-item>
              <el-form-item label="码牌号">
                <el-input v-model="bindingBasic.fUserPassword" style="width: 30%" type="textarea" :rows="4"></el-input>
              </el-form-item>
              <el-form-item label="码牌数" prop="fUserName">
                <el-input v-model="bindingBasic.headShopMerchantId"  style="width: 30%" :disabled = 'true'></el-input>
              </el-form-item>
              <el-form-item label="商户编号">
                <el-input v-model="bindingBasic.fUserPassword" style="width: 30%"></el-input>
              </el-form-item>
            </el-form>
        </el-row>
        <span slot="footer" class="dialog-footer" style="width:100%">
           <el-button icon="el-icon-save" type="primary" >绑定</el-button>
           <el-button @click="dialogBinding = false" >取消</el-button>
        </span>
      </el-dialog> -->
    <!-- 码牌绑定(单个) -->
    <el-dialog title="码牌绑定" :visible.sync="dialogSingleBinding" size="small">
      <el-row >
        <el-form
          label-width="100px"
          ref="bindingBasic"
          :model="bindingBasic"
          :rules="rule_data">
          <el-form-item label="码牌号">
            <el-input v-model="bindingBasic.fQrcodeNum" style="width: 30%" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="码牌数">
            1
          </el-form-item>
          <el-form-item label="绑定时间">
            <el-input v-model="bindingBasic.bindingTime" style="width: 30%" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="代理商">
            <el-input v-model="currentAgentId" style="width: 30%" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="绑定人">
            <el-input v-model="userName" style="width: 30%" :disabled="true"></el-input>
            <label style="margin:0 60px">批次号</label>
            <el-input v-model="bindingBasic.fBatchNo" style="width: 30%" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="商户编号" prop="fMerchantId" >
            <el-input v-model="bindingBasic.fMerchantId" style="width: 30%"></el-input>
          </el-form-item>
        </el-form>
      </el-row>
      <span slot="footer" class="dialog-footer" style="width:100%">
        <el-button icon="el-icon-save" type="primary" @click="submitSingleBinding('bindingBasic')" :loading="bindingBasic.bindingLoading">绑定</el-button>
        <el-button @click="dialogSingleBinding = false" >取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import QRCode from 'qrcodejs2'
import qs from 'qs'
// export default {RecordJs};
import { cancelDistributeQrcode, getQrcodePage, listDistributeQrcode, distributeByAgent, changeQrcodeState, getQrcodeType } from '@/api/machine'
import { fabric } from 'fabric'
export default {
  data () {
    return {
      comeTime: '',
      qrcode_list: [],
      group_list: [],
      bank_list: [],
      pro_list: [],
      city_list: [],
      area_list: [],
      bank_pro_list: [],
      bank_city_list: [],
      branch_list: [],
      effect_privilege_level_list: [],
      areas: [],
      citys: [],
      data: [],
      pos: [],
      scan: [],
      dataParam: {},
      domain: 'https://pos.yeahka.com/',
      picDomain: 'https://pic.yeahka.com/',
      table_type: 'sale',
      form_type: 'sale',
      qrCodeNum: '',
      staffsNum: '',
      roleName: '',
      qrcodeLoading: false,
      dialogVisible: false,
      dialogDistribute: false,
      dialogBinding: false,
      dialogSingleBinding: false,
      addLoading: false,
      authLoading: false,
      picLoading: false,
      zfztDisabledInput: true,
      gzztDisabledInput: true,
      groupIdDisabledInput: false,
      disabledInput: false,
      editLoading: false,
      holderDisabledInput: false,
      headShopMerchantIdInput: false,
      publicsignalAppidGZItem: true,
      publicsignalAppidItem: true,
      publicsignalAuthorizationDirectoryItem: true,
      dialogDisabled: false,
      settleDialogDisabled: false,
      settleToDisabled: false,
      nopassReason: false,
      showTypeCheckBox: true,
      editable: false,
      distributeBasic: {
        startQrcodeNum: '',
        endQrcodeNum: '',
        totalQrcodeCount: '',
        distributeAgentId: '',
        distributeCodeDisabled: false,
        distributeLoading: false,
        batchType: ''
      },
      bindingBasic: {
        bindingTime: '',
        fQrcodeNum: '',
        fBatchNo: '',
        fMerchantId: '',
        bindingLoading: false
      },
      currentAgentId: '',
      totalAmountCount: {
        qrCodeCount: '',
        bindCount: '',
        noBindCount: ''
      },
      picLoadingArr: [{ idcardFront: false }, { idcardBack: false },
        { bankcardFront: false },
        { businessLicenseC: false },
        { doorPhoto: false },
        { cashierDesk: false },
        { businessInside: false },
        { nonLegSettleAuth: false },
        { nonLegIdcardFront: false },
        { nonLegIdcardBack: false },
        { protocolPage: false },
        { taxRegCert: false },
        { organizationCode: false },
        { leaseContract: false }],
      // 修改界面数据
      other: {
        mccType: '',
        gzzt: '', // 关注主体
        zfzt: '' // 支付主体
      },
      fRate: '',
      userId: '',
      userName: '',
      /** startQrcodeNum:[{
            validator: (rule, value, callback) => {
              if (!(/^LS\d{10}$/.test(value))) {
                callback(new Error('请输入正确的码牌号'))
              } else {
                callback()
              }
            },
            required: true,
            trigger: 'change'
          }],
          endQrcodeNum:[{
            validator: (rule, value, callback) => {
              if (!(/^LS\d{10}$/.test(value))) {
                callback(new Error('请输入正确的码牌号'))
              } else {
                callback()
              }
            },
            required: true,
            trigger: 'change'
          }], **/
      rule_data: {

        distributeAgentId: [
          { required: true, message: '请输入下级代理/业务员', trigger: 'blur' }
        ],
        fMerchantId: [
          { required: true, message: '请输入商户编号', trigger: 'blur' }
        ]
      },
      // 搜索表单信息
      search_qrcode: {
        FCreateStartTime: '',
        FCreateEndTime: '',
        FQrcodeNum: '',
        FState: '',
        FDistributeState: '',
        FBatchNo: '',
        FAgentId: '',
        pageNo: '',
        pageSize: '',
        totalCount: '',
        FShopType: '',
        FSettleTo: '',
        FType: ''
      },
      checkBasic: {
        qrcodeNum: '',
        qrUrL: '',
        qrcode: null,
        checkLoading: false,
        imgsrc: '',
        show: true
      },
      licenseChecked: false,
      pics: {
        idcardFront: '',
        idcardBack: '',
        bankcardFront: '',
        businessLicenseC: '',
        doorPhoto: '',
        cashierDesk: '',
        businessInside: '',
        protocolPage: '',
        nonLegSettleAuth: '',
        nonLegIdcardFront: '',
        nonLegIdcardBack: '',
        taxRegCert: '',
        organizationCode: '',
        leaseContract: '',
        // 上面是绝对路径，存储到数据库，下面是url，显示到页面
        idcardFrontUrl: '',
        idcardBackUrl: '',
        bankcardFrontUrl: '',
        businessLicenseCUrl: '',
        doorPhotoUrl: '',
        cashierDeskUrl: '',
        businessInsideUrl: '',
        protocolPageUrl: '',
        nonLegSettleAuthUrl: '',
        taxRegCertUrl: '',
        organizationCodeUrl: '',
        leaseContractUrl: ''
      },

      // 需要给分页组件传的信息
      paginations: {
        pageNum: 1,
        total: 0,
        pageSize: 10,
        pageSizes: [10],
        layout: 'total, prev, pager, next, jumper'
      },
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      qrcodeTypeList: []
    }
  },
  mounted () {
    this.setDefaultDate()
    this.getQrcodeTypeFn()
    this.getList()
  },
  methods: {
    dateChange (value) {
      if (value !== null) {
        value[0] = value[0].getFullYear() + '-' + (((value[0].getMonth() + 1) < 10) ? ('0' + (value[0].getMonth() + 1)) : (value[0].getMonth() + 1)) + '-' + ((value[0].getDate() < 10) ? ('0' + value[0].getDate()) : (value[0].getDate())) + ' 00:00:00'
        value[1] = value[1].getFullYear() + '-' + (((value[1].getMonth() + 1) < 10) ? ('0' + (value[1].getMonth() + 1)) : (value[1].getMonth() + 1)) + '-' + ((value[1].getDate() < 10) ? ('0' + value[1].getDate()) : (value[1].getDate())) + ' 23:59:59'
        this.search_qrcode.FCreateStartTime = value[0]
        this.search_qrcode.FCreateEndTime = value[1]
      } else {
        this.search_qrcode.FCreateStartTime = ''
        this.search_qrcode.FCreateEndTime = ''
      }
    },
    setDefaultDate () {
      const end = new Date()
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
      this.comeTime = [start, end]
      this.dateChange(this.comeTime)
    },
    // 取消分配
    cancelDistribute (row, index, scope) {
      var qrcodeNum = row.fQrcodeNum
      var data = {
        FQrcodeNum: qrcodeNum
      }
      data = qs.stringify(data)
      this.$confirm(
        '确认取消分配码牌' + qrcodeNum + '?', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
        cancelDistributeQrcode(data).then((data) => {
          if (parseInt(data.error_code) === 0) {
            this.$message({
              message: '操作成功',
              type: 'success'
            })
          } else {
            this.$message({
              message: data.error_msg,
              type: 'error'
            })
          }
          this.getList()
        })
      })
    },
    // 显示查看界面
    handleCheck (index, row, scope) {
      if (this.checkBasic.qrcode !== null) {
        document.getElementById('img_box').innerHTML = ''
      }
      this.dialogVisible = true
      if (row.fQrcodeType !== null && row.fQrcodeType === 2) { // 银联固码
        this.checkBasic.show = true
      } else { // 其他
        this.checkBasic.show = false
      }
      this.checkBasic.checkLoading = true
      this.checkBasic.qrcode = null
      this.checkBasic.qrcodeNum = row.fQrcodeNum
      this.checkBasic.qrUrl = ''
      this.checkBasic.merchantName = row.fMerchantName
      // var merchantId  = row.fMerchantId;//商户编号
      var merchantId = 11111111// 商户编号,默认为"11111111"
      var qrcodeNum = row.fQrcodeNum// 码牌号
      var data = {
        FMerchantId: merchantId,
        FQrcodeNum: qrcodeNum
      }
      data = qs.stringify(data)
      getQrcodePage(data).then(response => {
        if (parseInt(response.error_code) === 0) {
          var qrUrl = response.qrUrl
          // if (row.fQrcodeType==null || (row.fQrcodeType!=2 && row.fQrcodeType!=5) ){//非银联固码
          //   qrUrl = qrUrl+"&source_type=33";
          // }
          this.qrCodeSave(qrUrl, qrcodeNum, row.fMerchantName)
        } else {
          this.$message({
            message: response.error_msg,
            type: 'error'
          })
        }
      })
    },
    qrCodeSave (qrUrl, qrcodeNum, merchantName) {
      var url = qrUrl
      const that = this
      document.getElementById('img_box').innerHTML = ''
      this.checkBasic.qrcode = new QRCode(document.getElementById('img_box'), {
        width: 200, // 设置宽高
        height: 200
      })
      this.checkBasic.qrcode.clear()
      this.checkBasic.qrcode.makeCode(url)
      // eslint-disable-next-line no-undef
      fabric.Object.prototype.transparentCorners = false
      // eslint-disable-next-line no-undef
      var canvas1 = window._canvas = new fabric.Canvas('main')
      this.$jquery('.canvas-container').addClass('hide')
      this.$jquery('#img_box img')[0].onload = function () {
        // var domain='https://pos.yeahka.com/';
        // domain+'../../../../static/images/unionPayCode.png'
        // wxs.yeahka.com:443/o2o/resources/images/unionPayCode.png
        var src = that.$jquery('.codeImgDownload').attr('src')
        // eslint-disable-next-line no-undef
        fabric.Image.fromURL(src, function (image) {
          image.set({
            width: 390,
            height: 500,
            top: -250,
            left: -250,
            margin: '0 auto'
          })
          var img1 = image.scale(1).setCoords()
          const merchantNameStr = `商户简称:${merchantName || '未设置'}`
          // eslint-disable-next-line no-undef
          const merchantNameText = new fabric.Text(merchantNameStr, {
            fontSize: 14,
            fill: '#333',
            textAlgin: 'center',
            left: -merchantNameStr.length * 14 / 2 - 50,
            top: -168
          })
          // const checkQRTipText = new fabric.Text('添加乐刷公众号(leshua2011)验真伪', {
          // eslint-disable-next-line no-undef
          const checkQRTipText = new fabric.Text('', {
            fontSize: 13,
            fill: '#27499d',
            textAlgin: 'center',
            left: -152,
            top: 150,
            margin: '0 auto'
          })
          // eslint-disable-next-line no-undef
          var text = new fabric.Text('NO：' + qrcodeNum, {
            fontSize: 10,
            fill: '#ffffff',
            textAlgin: 'center',
            left: -125,
            top: 230
          })
          // eslint-disable-next-line no-undef
          fabric.Image.fromURL(that.$jquery('#img_box img').attr('src'), function (image) {
            image.set({
              width: 200,
              height: 200,
              left: -152,
              top: -138
            })
            // new fabric.Image.filters.RemoveWhite({threshold: 60, distance: 60})
            var img2 = image.scale(1).setCoords()
            // eslint-disable-next-line no-undef
            var group = new fabric.Group([img1, merchantNameText, checkQRTipText, img2, text], {
              width: 766,
              height: 902
            },
            {
              width: 300,
              height: 300
            },
            {
              width: 300,
              height: 300
            }
            )
            // var text = image.scale(1).setCoords();
            canvas1.add(group)
            canvas1.renderAll()
            canvas1.calcOffset()
            canvas1.setActiveObject(group)
            that.$jquery('#ewm_img img').attr('src', canvas1.toDataURL({
              format: 'png',
              quality: 0.4,
              width: 663,
              height: 910
            }))
          })
        })
      }
      this.checkBasic.checkLoading = false
    },
    // 保存二维码
    saveQrcode () {
      console.info(1)
      this.checkBasic.checkLoading = true
      var url = this.$jquery('#ewm_img #top_img').attr('src')
      var triggerDownload = this.$jquery('#hello').attr('href', url).attr('download', '乐刷扫码二维码.png')
      triggerDownload[0].click()
      this.checkBasic.checkLoading = false
    },
    /**
       * 改变当前页事件
       * @param  {number} page 当前页码
       */
    onChangeCurrentPage (page) {
      var totalCount = this.qrCodeNum
      // var pageSize = this.qrcode_list.length;
      this.search_qrcode.pageNo = page
      // this.search_qrcode.pageSize = pageSize;
      this.search_qrcode.Count = totalCount
      // this.search_qrcode.pageSize = size;
      this.getList()
    },
    /**
       * 改变每页显示数量事件
       * @param  {number} size 当前每页显示数量
       */
    onChangePageSize (size) {
      console.log(this)
      var totalCount = this.qrCodeNum
      var pageNo = this.paginations1.pageNum
      this.search_qrcode.pageSize = size
      this.search_qrcode.pageNo = pageNo
      this.search_qrcode.Count = totalCount
      this.onSearch()
    },
    formatSearch (search) {
      var data = Object.assign({}, search)
      for (var s in data) {
        if (!data[s] && data[s] !== 0) {
          delete data[s]
        }
      }
      return data
    },
    // 点击搜索按钮事件
    onSearch () {
      this.qrcodeLoading = true
      // this.search_qrcode.pageNo = 1;
      this.getList()
    },
    /* 点击查询按钮事件 */
    buttomSearch () {
      // 当点击查询时，显示第一页
      this.search_qrcode.pageNo = 1
      // 让页码数回归到1
      this.paginations.total = 0
      this.onSearch()
    },
    getList () {
      this.qrcodeLoading = true
      var data = this.formatSearch(this.search_qrcode)
      data = qs.stringify(data)

      listDistributeQrcode(data).then((data) => {
        if (parseInt(data.error_code) !== 0) {
          this.$message({
            showClose: true,
            message: data.error_msg,
            type: 'error'
          })
          this.qrcodeLoading = false
        } else {
          this.qrcodeLoading = false
          this.paginations.total = data.data.totalCount
          this.qrcode_list = data.data.list
          this.qrCodeNum = data.data.totalCount
          this.totalAmountCount.qrCodeCount = data.data.qrcodeCount
          this.totalAmountCount.noBindCount = data.data.noBindCount
          this.totalAmountCount.bindCount = data.data.bindCount
          this.userName = data.data.currentAgentName
          this.currentAgentId = data.data.currentAgentId
        }
      })
    },
    tableSortChange (val) {
      this.getList()
    },
    formatDistributeState (item) {
      return item.fDistributeState === 0 ? '未分配' : '已分配'
    },
    formatType (item) {
      if (item.fQrcodeType === 2) return '乐刷收款二维码'
      const typeList = this.qrcodeTypeList.filter(function (type) {
        return type.code === item.fQrcodeType
      })
      if (typeList.length > 0) {
        return typeList[0].name
      } else {
        return '未知'
      }
    },
    formatState (item) {
      var str = ''
      if (item.realState === 0) {
        str = '关闭'
      } else {
        str = item.fState === 0 ? '关闭' : '开通'
      }
      return str
    },
    /* 码牌分配 */
    handleDistribute (row) {
      if (row) {
        // var type = 1
        // if (row.fQrcodeType === 1) {
        //   type = 1
        // } else if (row.fQrcodeType === 2) {
        //   type = 1
        // } else if (row.fQrcodeType === 3) {
        //   type = 2
        // } else if (row.fQrcodeType === 4) {
        //   type = 3
        // } else if (row.fQrcodeType === 5) {
        //   type = 4
        // }

        this.distributeBasic.startQrcodeNum = row.fQrcodeNum
        this.distributeBasic.endQrcodeNum = row.fQrcodeNum
        this.distributeBasic.distributeCodeDisabled = true
        this.distributeBasic.totalQrcodeCount = 1
        // this.distributeBasic.batchType = type;
        this.showTypeCheckBox = false
      } else {
        this.distributeBasic.startQrcodeNum = ''
        this.distributeBasic.endQrcodeNum = ''
        this.distributeBasic.distributeCodeDisabled = false
        this.distributeBasic.totalQrcodeCount = ''
        // this.distributeBasic.batchType = "";
        this.showTypeCheckBox = true
      }
      this.dialogDistribute = true
      this.distributeBasic.distributeAgentId = ''
    },
    handleDistributeCodeStartBlur () {
      var sqn = this.distributeBasic.startQrcodeNum
      var eqn = this.distributeBasic.endQrcodeNum
      var tqc = this.distributeBasic.totalQrcodeCount
      if (sqn !== '' && tqc !== '') {
        this.handleDistributeCodeCountBlur()
      } else if (sqn !== '' && eqn !== '') {
        this.handleDistributeCodeEndBlur()
      }
    },
    handleDistributeCodeEndBlur () {
      var sqn = this.distributeBasic.startQrcodeNum
      var eqn = this.distributeBasic.endQrcodeNum
      var s
      var e
      var tqc
      if (sqn !== '' && eqn !== '') {
        if ((/^LS\d{10}$/.test(sqn)) && (/^LS\d{10}$/.test(eqn))) {
          s = parseInt('1' + sqn.substring(2, 12))
          e = parseInt('1' + eqn.substring(2, 12))
          tqc = e - s + 1
          this.distributeBasic.totalQrcodeCount = tqc > 0 ? tqc : ''
        } else if ((/^LSX\d{10}$/.test(sqn)) && (/^LSX\d{10}$/.test(eqn))) {
          s = parseInt('1' + sqn.substring(3, 13))
          e = parseInt('1' + eqn.substring(3, 13))
          tqc = e - s + 1
          this.distributeBasic.totalQrcodeCount = tqc > 0 ? tqc : ''
        } else if ((/^LSY\d{10}$/.test(sqn)) && (/^LSY\d{10}$/.test(eqn))) {
          s = parseInt('1' + sqn.substring(3, 13))
          e = parseInt('1' + eqn.substring(3, 13))
          tqc = e - s + 1
          this.distributeBasic.totalQrcodeCount = tqc > 0 ? tqc : ''
        } else if ((/^LSKJ\d{10}$/.test(sqn)) && (/^LSKJ\d{10}$/.test(eqn))) {
          s = parseInt('1' + sqn.substring(4, 14))
          e = parseInt('1' + eqn.substring(4, 14))
          tqc = e - s + 1
          this.distributeBasic.totalQrcodeCount = tqc > 0 ? tqc : ''
        } else if ((/^HSY\d{10}$/.test(sqn)) && (/^HSY\d{10}$/.test(eqn))) {
          s = parseInt('1' + sqn.substring(3, 13))
          e = parseInt('1' + eqn.substring(3, 13))
          tqc = e - s + 1
          this.distributeBasic.totalQrcodeCount = tqc > 0 ? tqc : ''
        } else if ((/^LSQ\d{10}$/.test(sqn)) && (/^LSQ\d{10}$/.test(eqn))) {
          s = parseInt('1' + sqn.substring(3, 13))
          e = parseInt('1' + eqn.substring(3, 13))
          tqc = e - s + 1
          this.distributeBasic.totalQrcodeCount = tqc > 0 ? tqc : ''
        } else if ((/^010117[0-9]{7}$/.test(sqn)) && (/^010117[0-9]{7}$/.test(eqn))) {
          s = parseInt('1' + sqn)
          e = parseInt('1' + eqn)
          tqc = e - s + 1
          this.distributeBasic.totalQrcodeCount = tqc > 0 ? tqc : ''
        } else if ((/^1501[0-9]{6}$/.test(sqn)) && (/^1501[0-9]{6}$/.test(eqn))) {
          s = parseInt('1' + sqn)
          e = parseInt('1' + eqn)
          tqc = e - s + 1
          this.distributeBasic.totalQrcodeCount = tqc > 0 ? tqc : ''
        } else if ((/^1502[0-9]{6}$/.test(sqn)) && (/^1502[0-9]{6}$/.test(eqn))) {
          s = parseInt('1' + sqn)
          e = parseInt('1' + eqn)
          tqc = e - s + 1
          this.distributeBasic.totalQrcodeCount = tqc > 0 ? tqc : ''
        } else if ((/^1503[0-9]{6}$/.test(sqn)) && (/^1503[0-9]{6}$/.test(eqn))) {
          s = parseInt('1' + sqn)
          e = parseInt('1' + eqn)
          tqc = e - s + 1
          this.distributeBasic.totalQrcodeCount = tqc > 0 ? tqc : ''
        } else if ((/^PayM1\d{8}$/.test(sqn))) {
          s = parseInt('1' + sqn.substring(5, 13))
          e = parseInt('1' + eqn.substring(5, 13))
          tqc = e - s + 1
          this.distributeBasic.totalQrcodeCount = tqc > 0 ? tqc : ''
        } else if ((/^JHSS\d{10}/.test(sqn)) && (/^JHSS\d{10}$/.test(eqn))) {
          s = parseInt('1' + sqn.substring(4, 14))
          e = parseInt('1' + eqn.substring(4, 14))
          tqc = e - s + 1
          this.distributeBasic.totalQrcodeCount = tqc > 0 ? tqc : ''
        } else {
          this.distributeBasic.totalQrcodeCount = ''
        }
      } else {
        this.distributeBasic.totalQrcodeCount = ''
      }
    },
    handleDistributeCodeCountBlur () {
      var sqn = this.distributeBasic.startQrcodeNum
      var tqc = this.distributeBasic.totalQrcodeCount
      var s
      var e
      var eStr
      if (sqn !== '' && tqc !== '') {
        if ((/^LS\d{10}$/.test(sqn))) {
          s = parseInt('1' + sqn.substring(2, 12))
          e = s + parseInt(tqc) - 1
          eStr = e + ''
          this.distributeBasic.endQrcodeNum = 'LS' + eStr.substring(1, eStr.length)
        } else if ((/^LSX\d{10}$/.test(sqn))) {
          s = parseInt('1' + sqn.substring(3, 13))
          e = s + parseInt(tqc) - 1
          eStr = e + ''
          this.distributeBasic.endQrcodeNum = 'LSX' + eStr.substring(1, eStr.length)
        } else if ((/^LSY\d{10}$/.test(sqn))) {
          s = parseInt('1' + sqn.substring(3, 13))
          e = s + parseInt(tqc) - 1
          eStr = e + ''
          this.distributeBasic.endQrcodeNum = 'LSY' + eStr.substring(1, eStr.length)
        } else if ((/^LSKJ\d{10}$/.test(sqn))) {
          s = parseInt('1' + sqn.substring(4, 14))
          e = s + parseInt(tqc) - 1
          eStr = e + ''
          this.distributeBasic.endQrcodeNum = 'LSKJ' + eStr.substring(1, eStr.length)
        } else if ((/^HSY\d{10}$/.test(sqn))) {
          s = parseInt('1' + sqn.substring(3, 13))
          e = s + parseInt(tqc) - 1
          eStr = e + ''
          this.distributeBasic.endQrcodeNum = 'HSY' + eStr.substring(1, eStr.length)
        } else if ((/^LSQ\d{10}$/.test(sqn))) {
          s = parseInt('1' + sqn.substring(3, 13))
          e = s + parseInt(tqc) - 1
          eStr = e + ''
          this.distributeBasic.endQrcodeNum = 'LSQ' + eStr.substring(1, eStr.length)
        } else if ((/^010117[0-9]{7}$/.test(sqn))) {
          s = parseInt('1' + sqn)
          e = s + parseInt(tqc) - 1
          eStr = e + ''
          this.distributeBasic.endQrcodeNum = eStr.substring(1, eStr.length)
        } else if ((/^1501[0-9]{6}$/.test(sqn)) || (/^1502[0-9]{6}$/.test(sqn)) || (/^1503[0-9]{6}$/.test(sqn))) {
          s = parseInt('1' + sqn)
          e = s + parseInt(tqc) - 1
          eStr = e + ''
          this.distributeBasic.endQrcodeNum = eStr.substring(1, eStr.length)
        } else if ((/^PayM1\d{8}$/.test(sqn))) {
          s = parseInt('1' + sqn.substring(5, 13))
          e = s + parseInt(tqc) - 1
          eStr = e + ''
          this.distributeBasic.endQrcodeNum = 'PayM1' + eStr.substring(1, eStr.length)
        } else if ((/^JHSS\d{10}$/.test(sqn))) {
          s = parseInt('1' + sqn.substring(4, 14))
          e = s + parseInt(tqc) - 1
          eStr = e + ''
          this.distributeBasic.endQrcodeNum = 'JHSS' + eStr.substring(1, eStr.length)
        } else {
          this.distributeBasic.endQrcodeNum = ''
        }
      } else {
        this.distributeBasic.endQrcodeNum = ''
      }
    },
    submitDistribute (distributeBasic) {
      var sqn = this.distributeBasic.startQrcodeNum
      var eqn = this.distributeBasic.endQrcodeNum
      var tc = this.distributeBasic.totalQrcodeCount
      var agentId = this.distributeBasic.distributeAgentId
      var batchType = this.distributeBasic.batchType
      // && (/^LS\d{10}$/.test(sqn)) && (/^LS\d{10}$/.test(eqn))
      if (sqn !== '' && eqn !== '' && tc !== '' && agentId !== '') {
        var s = parseInt('1' + sqn.substring(5, 12))
        var e = parseInt('1' + eqn.substring(5, 12))
        var tqc = e - s + 1
        if (tqc <= 0) {
          this.$message({
            showClose: true,
            message: '起始码牌号不得大于终止码牌号',
            type: 'error'
          })
        } else {
          var data = {
            startQrcodeNum: sqn,
            endQrcodeNum: eqn,
            totalCount: tc,
            distributeAgentId: agentId,
            batchType: batchType
          }
          data = qs.stringify(data)
          this.distributeBasic.distributeLoading = true
          distributeByAgent(data).then(data => {
            this.distributeBasic.distributeLoading = false
            if (parseInt(data.error_code) === 0) {
              this.$message({
                message: '分配成功',
                type: 'success'
              })
              this.dialogDistribute = false
              this.getList()
            } else {
              var msg = '分配失败'
              if (data && data.error_msg !== null && data.error_msg !== '') {
                msg = data.error_msg
              }
              this.$message({
                message: msg,
                type: 'error'
              })
            }
          })
        }
      } else {
        this.$message({
          showClose: true,
          message: '数据填写错误，请检查后重试',
          type: 'error'
        })
      }
    },
    /* 码牌绑定 */
    // handleBinding() {
    //   this.dialogBinding = true;
    // },
    /* 码牌绑定（单个） */
    handleSingleBinding (row, index, scope) {
      this.dialogSingleBinding = true
      this.bindingBasic.bindingTime = this.getNowFormatDate()
      this.bindingBasic.fQrcodeNum = row.fQrcodeNum
      this.bindingBasic.fQrcodeNum = row.fQrcodeNum
      this.bindingBasic.fBatchNo = row.fBatchNo
      this.bindingBasic.fMerchantId = ''
    },
    submitSingleBinding (bindingBasic) {
      var mId = this.bindingBasic.fMerchantId
      if (mId === '') {
        this.$message({
          showClose: true,
          message: '请输入商户编号',
          type: 'error'
        })
      } else {
        // OperationType 0.交易开通/关闭 1.备注开通关闭 2.绑定、解绑
        var operationType = 2
        // fbs 绑定/解绑标志 1、绑定 2.解绑
        var fbs = 1
        var data = {
          FQrcodeNum: this.bindingBasic.fQrcodeNum,
          OperationType: operationType,
          FBindState: fbs,
          FMerchantId: mId
        }
        data = qs.stringify(data)
        this.bindingBasic.bindingLoading = true
        changeQrcodeState(data).then(data => {
          this.bindingBasic.bindingLoading = false
          if (parseInt(data.error_code) === 0) {
            this.$message({
              message: '绑定成功',
              type: 'success'
            })
            this.dialogSingleBinding = false
            this.getList()
          } else {
            this.$message({
              message: data.error_msg,
              type: 'error'
            })
          }
        })
      }
    },
    getNowFormatDate () {
      var date = new Date()
      var seperator1 = '-'
      var seperator2 = ':'
      var month = date.getMonth() + 1
      var strDate = date.getDate()
      if (month >= 1 && month <= 9) {
        month = '0' + month
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = '0' + strDate
      }
      var currentdate = date.getFullYear() + seperator1 + month + seperator1 + strDate +
                ' ' + date.getHours() + seperator2 + date.getMinutes() +
                seperator2 + date.getSeconds()
      return currentdate
    },
    /**
       * 获取码牌类型
       */
    getQrcodeTypeFn () {
      getQrcodeType('').then(response => {
        console.log('getQrcodeType response:', response)
        this.qrcodeTypeList = response.list || []
      })
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .demo-inline-form {
    margin-top: 18px;
  }

  .btm-action {
    margin: 20px 0;
    text-align: center;
  }

  .pagination {
    display: inline-block;
  }
  .list{
    padding-left: 16px;
  }
  /deep/ .el-form-item__label{
    text-align: left;
  }
  .codeImgBox {
    width: 390px;
    height: 500px;
    border-radius: 20px;
    // margin: 46px 0 30px 46px;
    margin: 0 auto;
    position: relative;
  }
  .codeImgBox .top_img {
    width: 100%;
  }
  .codeImgBox #img_box {
    width: 200px;
    height: 200px;
    position: relative;
    bottom: 79%;
    left: 24%;
  }
  .codeImgBox #img_box img {
    width: 100%;
    height: 100%;
  }
  .codeImgBox #leposNum {
    position: absolute;
    font-size: 10px;
    color: #fff;
    width: 100%;
    text-align: center;
    /* display: none; */
    top: 93%;
    left: 0%;
  }
  .codeImgBox .qr-code-tip-view {
    position: absolute;
    width: 100%;
    top: 16%;
    font-size: 14px;
    text-align: center;
  }
  .codeImgBox .qr-code-tip-view > div {
    height: 20px;
    line-height: 20px;
  }
  .hide {
    display: none;
  }
</style>
